import React, { FC } from 'react'
import { Box, Grid } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { TradingBalances } from '../TreasurySections/TradingBalances'
import { SettelmentAddresses } from '../TreasurySections/SettelmentAddresses'
import { TradeHistory } from '../TreasurySections/TradeHistory'
import { StakingBalances } from '../TreasurySections/StakingBalances'
import { Transactions } from '../TreasurySections/Transactions'
import { GridRow } from '../../../../../components/GridRow'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
}))

export const CompanyHistory: FC = () => {
  const classes = useStyles()

  return (
    <Box className={classes.container}>
      <GridRow spacing={4}>
        <Grid item xs={4}>
          <TradingBalances title={'Trading Balances'} />
        </Grid>
        <Grid item xs={4}>
          <SettelmentAddresses title={'Settlement Addresses'} />
        </Grid>
        <Grid item xs={4}>
          <TradeHistory title={'Trade History'} />
        </Grid>
      </GridRow>
      <GridRow spacing={4}>
        <Grid item xs={4}>
          <StakingBalances title={'Staking Balances'} />
        </Grid>
        <Grid item xs={8}>
          <Transactions title={'Transactions'} />
        </Grid>
      </GridRow>
    </Box>
  )
}
